import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlarmFieldUnauthorizedScheduleComponent } from './alarm-field-unauthorized-schedule.component';
import {CardComponent} from "../../../@theme/components/card/card.component";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatInputModule} from "@angular/material/input";
import {FieldSelectModule} from "@mri/app/modules";



@NgModule({
  declarations: [
    AlarmFieldUnauthorizedScheduleComponent
  ],
  exports: [
    AlarmFieldUnauthorizedScheduleComponent
  ],
  imports: [
    CommonModule,
    CardComponent,
    MatSlideToggleModule,
    MatInputModule,
    FieldSelectModule
  ]
})
export class AlarmFieldUnauthorizedScheduleModule { }
